import { render, staticRenderFns } from "./msInputSearch.vue?vue&type=template&id=8012838a&scoped=true"
import script from "./msInputSearch.vue?vue&type=script&lang=js"
export * from "./msInputSearch.vue?vue&type=script&lang=js"
import style0 from "./msInputSearch.vue?vue&type=style&index=0&id=8012838a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8012838a",
  null
  
)

export default component.exports